import { Controller } from "stimulus"

// Choose Shopping Method page: keeps the two "Continue to Next Step" links (plan selection
// vs. the Checkbook / Plan Compare modal) in sync with the selected guidance radio.
//
// syncLinks() runs on connect and on `pageshow`, so the links match the checked radio even
// after a back-navigation bfcache restore — which the previous change-only handler missed.
export default class extends Controller {
  connect() {
    this.radios = Array.from(this.element.querySelectorAll('input[name="guidance"]'))
    this.planShoppingLink = this.element.querySelector("#plan-shopping-link")
    this.checkbookLink = this.element.querySelector("#checkbook-link")

    this._onChange = () => this.syncLinks()
    this._onPageShow = () => this.syncLinks()
    this.radios.forEach((radio) => radio.addEventListener("change", this._onChange))
    window.addEventListener("pageshow", this._onPageShow)

    this.syncLinks()
  }

  disconnect() {
    this.radios.forEach((radio) => radio.removeEventListener("change", this._onChange))
    window.removeEventListener("pageshow", this._onPageShow)
  }

  syncLinks() {
    const knowsPlan = this.radios.some((radio) => radio.checked && radio.value === "false")

    if (this.planShoppingLink) {
      this.planShoppingLink.classList.toggle("hidden", !knowsPlan)
    }
    if (this.checkbookLink) {
      this.checkbookLink.classList.toggle("hidden", knowsPlan)
    }
  }
}
